import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useMutation, useQueryClient } from "react-query";
import { getCustomerRegistrationInfo, registerLoanBySupplier } from "../../services/loan.service";
import { CUSTOMER_BIRTHDATE, CUSTOMER_INFO, CUSTOMER_MOBILENUMBER, EXISTING_LOANREQUEST, HAS_REGISTER_REQUEST, INQUIRY_OTP_REF_KEY, INSTALLMENT_COUNT, INSTALLMENT_STEP, IS_CANCELABLE, IS_EDITABLE, LOAN_AMOUNT, LOAN_ID, LOAN_TEMPLATE_INFOS, NATIONAL_CODE, POSTAL_CODE, REFERENCE_KEY } from "../../config/cacheKey";
import { CustomerInfo, GetCustomerRegistrationInfoRequest, RegisterLoanBySupplierRequest, RegisterLoanBySupplierResponse } from "../../models/loan.model";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import * as Yup from "yup";
import { HandleNext } from "../../models/sharedFunctions";
import { useDispatch } from "react-redux";
import { setStep } from "../../redux/activeStep/activeStepAction";
import ModalCmp from "./ModalBluCmp";
const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};


export default function ModalinquiryOtp({ openModel }: any) {
  const dispatch = useDispatch();
  const handelStep = () => {
    dispatch(setStep({ step: 3 }));
  };
  const [open, setOpen] = React.useState<boolean>(openModel);
  const [openValidationModel, setOpenValidationModel] = React.useState(false);
  const [validationMessages, setValidationMessages] = React.useState<string[]>(
    []
  );
  const [openVerifyModal, setOpenVerifyModal] = React.useState(false);
  const [submitFlag, setSubmitFlag] = React.useState<boolean>(true);
  const [customerInfo, setCustomerInfo] = React.useState<CustomerInfo>(
    (): CustomerInfo => {
      let customerInfo = new CustomerInfo();
      return customerInfo;
    }
  );
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const queryClient = useQueryClient();
  //const loanRequestId = queryClient.getQueryData<string>(loadreq);
  const valuesNationalCode = new GetCustomerRegistrationInfoRequest();

  valuesNationalCode.nationalCode = queryClient.getQueryData<string>(
    NATIONAL_CODE
  );
  const registerLoanBySupplierMutation = useMutation(registerLoanBySupplier, {
    onSuccess: (data: RegisterLoanBySupplierResponse) => {
      setOpenValidationModel(false);
      setOpenVerifyModal(false);
      if (data) {
        if (!data.isValid) {
          setSubmitFlag(true);
          setOpen(false)
          setOpenValidationModel(true);
          setValidationMessages(data.validationIssues);
        } else {
          setSubmitFlag(false);
          setCustomerInfo(data.customerInfo);
          queryClient.setQueryData(REFERENCE_KEY, data.referenceKey);
          getCustomerRegistrationInfo(valuesNationalCode).then((data) => {
            queryClient.setQueryData(
              HAS_REGISTER_REQUEST,
              data.hasRegisterRequest
            );
            queryClient.setQueryData(IS_EDITABLE, data.isEditable);
            queryClient.setQueryData(IS_CANCELABLE, data.isCancelable);
            queryClient.setQueryData(CUSTOMER_INFO, data.customerInfo);
            queryClient.setQueryData(
              LOAN_TEMPLATE_INFOS,
              data.loanTemplateInfos
            );
            queryClient.setQueryData(
              EXISTING_LOANREQUEST,
              data.existingLoanRequest
            );
            setOpen(false)
            handelStep();
          });
          // CustomerRegistrationInfo.mutate(valuesNationalCode);
        }
      } else {
        setSubmitFlag(true);
      }
    },
    onError: () => {
      setSubmitFlag(true);
    },
  });

  const handelCancel = () => {
    handleClose();
  };

  const validationFatcorNumber = Yup.object().shape({
    inquiryOtp: Yup.string().required("فیلد اجباری است.").matches(/^[0-9]+$/, "کد استعلامی عدد می باشد.")//.min(5).max(5)

  });

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Formik
          validateOnMount={true}
          initialValues={new RegisterLoanBySupplierRequest()}
          validationSchema={validationFatcorNumber}
          onSubmit={async (values) => {
            if (submitFlag) {
              values.customerBirthDate = queryClient.getQueryData<Date>(CUSTOMER_BIRTHDATE);
              values.customerMobileNumber = queryClient.getQueryData<string>(CUSTOMER_MOBILENUMBER);
              values.customerNationalCode = queryClient.getQueryData<string>(NATIONAL_CODE);
              values.installmentCount = queryClient.getQueryData<number>(INSTALLMENT_COUNT);
              values.installmentStepSpace = queryClient.getQueryData<number>(INSTALLMENT_STEP);
              values.loanAmount = queryClient.getQueryData<number>(LOAN_AMOUNT);
              values.loanTemplateId = queryClient.getQueryData<number>(LOAN_ID);
              values.postalCode = queryClient.getQueryData<string>(POSTAL_CODE);
              values.inquiryOtpRefKey = queryClient.getQueryData<string>(INQUIRY_OTP_REF_KEY);
              await registerLoanBySupplierMutation.mutateAsync(values);
            }
          }}>
          {({ handleSubmit, values, errors,
            touched, handleChange, handleBlur }) => (
            <form onSubmit={handleSubmit}>
              <Box
                sx={style}
                style={{ borderRadius: "6px", padding: "40px 70px 70px 60px" }}
                className="ModalCmp textCenter "
              >
                <div>
                  <Typography className="textCenter mTop30 mbottom20">
                    <span>جهت دریافت استعلام، کد ارسال شده برای متقاضی را وارد نمایید.</span>
                  </Typography>
                  <MaterialTextFieldComponent
                    autoFocus={true}
                    helperText={
                      touched.inquiryOtp ? errors.inquiryOtp : ""
                    }
                    error={
                      touched.inquiryOtp && Boolean(errors.inquiryOtp)
                    }
                    placeHolder={"کد یکبار مصرف "}
                    label={"کد یکبار مصرف "}
                    required={true}
                    value={values.inquiryOtp}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="inquiryOtp"
                    id="inquiryOtp"
                  />
                </div>
                <Grid container spacing={2} columns={16} className="mTop20">
                  <Grid item xs={8}>
                    <Button
                      type="submit"
                      fullWidth
                      className="btnForm SuccessDefault"
                    >
                      ارسال
                    </Button>
                  </Grid>
                  <Grid item xs={8}>
                    <Button
                      onClick={handelCancel}
                      fullWidth
                      className="btnForm ComingBack"
                    >
                      بازگشت
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </form>
          )}
        </Formik>
      </Modal>
      <ModalCmp
        openModel={openValidationModel}
        validationMessages={validationMessages}
        firstPartOfTitle=" درخواست تسهیلات به دلایل زیر"
        boldTitle="پذیرفته"
        secondPartOfTitle="نشد:"
      />
    </div>
  );
}


